<script setup lang="ts">
defineProps<{ to: string; text: string }>();
</script>

<template>
  <AppLink
    type="text"
    :to
    :opts="{ size: '2xl', link: { external: true } }"
    class="text-client-black font-medium whitespace-nowrap"
  >
    <template #default>
      {{ text }}
    </template>
    <template #icon>
      <SVGArrowRounded class="size-6 rotate-135" />
    </template>
  </AppLink>
</template>
